module.exports = __webpack_public_path__ + "static/media/uadvisory-tick.30f1b558.svg";